(function () {
    var mediaQuery = window.matchMedia('(max-width: 991px)');

    var head = document.querySelector('.gh-head');
    var menu = head.querySelector('.gh-head-menu');
    var nav = menu.querySelector('.nav');
    if (!nav) return;

    // Multi-level Submenu Support
    var items = nav.querySelectorAll('li');
    var parents = []; // Stack to keep track of parents at each depth level

    items.forEach(function (li) {
        var link = li.querySelector('a');
        if (!link) return;
        
        var rawText = link.textContent.trim();
        var match = rawText.match(/^([-]+)\s*(.*)/);
        
        if (match) {
            var depth = match[1].length; // number of dashes
            var cleanText = match[2];
            var parent = parents[depth - 1]; // Parent is one level up

            if (parent) {
                var submenu = parent.querySelector('.submenu');
                if (!submenu) {
                    submenu = document.createElement('ul');
                    submenu.className = 'submenu';
                    parent.appendChild(submenu);
                    parent.classList.add('has-submenu');
                    
                    // Mobile and tablet toggle handling
                    parent.addEventListener('click', function (e) {
                        if (window.matchMedia('(max-width: 991px)').matches) {
                            if (e.target.tagName === 'A' && e.target.parentElement === parent) {
                                e.preventDefault();
                                e.stopPropagation();
                                parent.classList.toggle('is-open');
                            }
                        }
                    }, false);
                }
                link.textContent = cleanText;
                submenu.appendChild(li);
                parents[depth] = li; // Current item can be parent for level + 1
                // Clear any leftover deeper parents
                parents.length = depth + 1;
            }
        } else {
            parents[0] = li;
            parents.length = 1;
        }
    });

    var logo = document.querySelector('.gh-head-logo');
    var navHTML = nav.innerHTML;

    if (mediaQuery.matches) {
        var itemsMobile = nav.querySelectorAll('li');
        itemsMobile.forEach(function (item, index) {
            item.style.transitionDelay = 0.03 * (index + 1) + 's';
        });
    }

    var windowClickListener;
    var makeDropdown = function () {
        if (mediaQuery.matches) return;
        var submenuItems = [];

        while ((nav.offsetWidth + 64) > menu.offsetWidth) {
            if (nav.lastElementChild) {
                submenuItems.unshift(nav.lastElementChild);
                nav.lastElementChild.remove();
            } else {
                return;
            }
        }

        if (!submenuItems.length) {
            document.body.classList.add('is-dropdown-loaded');
            return;
        }

        var toggle = document.createElement('button');
        toggle.setAttribute('class', 'nav-more-toggle');
        toggle.setAttribute('aria-label', 'More');
        toggle.innerHTML = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" fill="currentColor"><path d="M21.333 16c0-1.473 1.194-2.667 2.667-2.667v0c1.473 0 2.667 1.194 2.667 2.667v0c0 1.473-1.194 2.667-2.667 2.667v0c-1.473 0-2.667-1.194-2.667 2.667v0zM13.333 16c0-1.473 1.194-2.667 2.667-2.667v0c1.473 0 2.667 1.194 2.667 2.667v0c0 1.473-1.194 2.667-2.667 2.667v0c-1.473 0-2.667-1.194-2.667-2.667v0zM5.333 16c0-1.473 1.194-2.667 2.667-2.667v0c1.473 0 2.667 1.194 2.667 2.667v0c0 1.473-1.194 2.667-2.667 2.667v0c-1.473 0-2.667-1.194-2.667-2.667v0z"></path></svg>';

        var wrapper = document.createElement('div');
        wrapper.setAttribute('class', 'gh-dropdown');

        if (submenuItems.length >= 10) {
            document.body.classList.add('is-dropdown-mega');
            wrapper.style.gridTemplateRows = 'repeat(' + Math.ceil(submenuItems.length / 2) + ', 1fr)';
        } else {
            document.body.classList.remove('is-dropdown-mega');
        }

        submenuItems.forEach(function (child) {
            wrapper.appendChild(child);
        });

        toggle.appendChild(wrapper);
        nav.appendChild(toggle);

        document.body.classList.add('is-dropdown-loaded');

        toggle.addEventListener('click', function () {
            document.body.classList.toggle('is-dropdown-open');
        });

        windowClickListener = function (e) {
            if (!toggle.contains(e.target) && document.body.classList.contains('is-dropdown-open')) {
                document.body.classList.remove('is-dropdown-open');
            }
        };
        window.addEventListener('click', windowClickListener);
    };

    imagesLoaded(head, function () {
        makeDropdown();
    });

    window.addEventListener('resize', function () {
        setTimeout(function () {
            window.removeEventListener('click', windowClickListener);
            nav.innerHTML = navHTML;
            makeDropdown();

            document.dispatchEvent(new CustomEvent('glowup:nav-rebuilt'));
            if (window.GlowUpMegaMenu && typeof window.GlowUpMegaMenu.init === 'function') {
                window.GlowUpMegaMenu.init(true);
            }
        }, 1);
    });
})();
